<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link to="/add-claims"
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          <i class="flaticon-plus position-relative ms-5 top-2 fs-15"></i>

          Nouvelle Réclamation
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Search "
          v-model="searchTerm"
          @change="filter()"
          @input="handleInput"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="headers" :rows="rows">
        <!-- Empty state -->
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <!-- Custom row -->
        <template #table-row="props">
          <span v-if="props.column.field == 'created_at'">
            {{ getDate(props.row.created_at) }}
          </span>

          <span v-else-if="props.column.field === 'statut'">
            <div
              v-if="props.row.statut == 4"
              class="badge text-bg-warning fs-13 me-5 mt-10"
            >
              En cours de traitement
            </div>
            <div
              v-if="props.row.statut == 1"
              class="badge text-bg-info fs-13 me-5 mt-10"
            >
              Réponse service
            </div>

            <div
              v-if="props.row.statut == 2"
              class="badge text-bg-primary fs-13 me-5 mt-10"
            >
              Réponse client
            </div>
            <div
              v-if="props.row.statut == 3"
              class="badge text-bg-success fs-13 me-5 mt-10"
            >
              Réclamation traitée
            </div>
          </span>

         <span v-else-if="props.column.field === 'object'">
          {{props.row.object}} 
          
          <i class="flaticon-chat-1  text-danger" v-if="getLastMsg(props.row.messages[0])"></i>
                <br/>
            <small style="color: #f08016;">{{props.row.code_colis}}
            <template v-if="props.row.new_price"> - <b> {{props.row.new_price}}</b></template>
            <template v-if="props.row.new_price_remb"> - <b> {{props.row.new_price_remb}} </b></template>
            </small>
        </span>

          <span v-else-if="props.column.field === 'city'">
            {{ props.row.city?.city }}
            <!-- <a target='_blank' :href="`${API_BASE_URL}/customer_details/${props.row.customer_id}`">{{props.row.store}}</a> -->
          </span>

          <!-- <template v-else-if="props.column.field === 'note'">
              <button
                style="margin-right: 1px; margin-left: 1px"
                variant="danger"
                class="btn-icon"
                title="Une remarque"
                @click="showDetailNote(props.row)"
              >
              </button>
            </template> -->
          <span v-else-if="props.column.field === 'created_at'">
            <h5>{{ getDate(props.row.created_at) }}</h5>

            <template
              v-if="props.row.taken_by_name && props.row.taken_by_name != ''"
            >
              Pris par: <span>{{ props.row.taken_by_name }}</span>
            </template>
          </span>

          <span v-else-if="props.column.field === 'last_response_by_name'">
            {{ props.row.last_response_by_name }}<br />
            <small>{{ getDate(props.row.response_time) }}</small>
          </span>

          <span v-else-if="props.column.field === 'code_colis'">
            {{ props.row.code_colis }}
          </span>

         

          <span v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <!-- Conversation -->
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="showUpdate(props.row)"
                  >
                    <i
                      class="ph ph-chat-circle-dots lh-1 me-8 position-relative top-1"
                    ></i>
                    Conversation
                  </a>
                </li>

                

                <!-- Traiter la réclamation -->
                <li v-if="props.row.statut !== 3">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showDetails(props.row)"
                  >
                    <i
                      class="flaticon-info lh-1 me-8 position-relative top-1"
                    ></i>
                    Informations
                  </a>
                </li>

                
              </ul>
            </div>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="fetchData"
      />
    </div>
  </div>

  <div class="modal fade" id="chatClaimModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Conversation réclamation</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <ChatClaim
            :messages="chatMsgs"
            :fetchMessages="fetchMessages"
            :rowClaim="showClaim"
          />
        </div>

        <!-- <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
        </div> -->
      </div>
    </div>
  </div>

  <div class="modal fade" id="infosClaimModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Informations réclamation</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
            <!-- Object -->
            <div class="form-group mb-3">
              <label for="object">Object</label>
              <input
                id="object"
                v-model="formClaim.object"
                disabled
                class="form-control"
              />
            </div>

            <hr />

            <!-- Colis (conditional) -->
            <div
              class="form-group mb-3"
              v-if="
                [
                  'Changement de prix',
                  'Relance Colis/Client',
                  'Annulation Colis',
                ].includes(formClaim.object)
              "
            >
              <label for="colis">Colis</label>
              <input
                id="colis"
                v-model="formClaim.code_colis"
                disabled
                class="form-control"
              />
            </div>

            <!-- Adresse/Client case -->
            <div
              v-if="formClaim.object === 'Changement Adresse/Client'"
              class="form-group mb-3"
            >
              <div>
                <label for="colis">Colis</label>
                <input
                  id="colis"
                  v-model="formClaim.code_colis"
                  disabled
                  class="form-control"
                />
              </div>
            </div>

            <!-- Nouveau Prix -->
            <div
              v-if="formClaim.object === 'Changement de prix'"
              class="form-group mb-3"
            >
              <label for="price">Nouveau Prix</label>
              <input
                id="price"
                v-model="formClaim.new_price"
                disabled
                class="form-control"
              />
            </div>

            <!-- Rembourssement -->
            <div
              v-if="formClaim.object === 'Rembourssement'"
              class="form-group mb-3"
            >
              <label for="price_remb">Nouveau Prix</label>
              <input
                id="price_remb"
                v-model="formClaim.new_price_remb"
                disabled
                class="form-control"
              />
            </div>

            <!-- City -->
            <div
              :class="
                formClaim.object === 'Changement Adresse/Client'
                  ? 'form-group mb-3'
                  : 'form-group mb-3'
              "
            >
              <label for="city">Ville</label>
              <input
                id="city"
                v-model="formClaim.city_name"
                disabled
                class="form-control"
              />
            </div>

            <!-- Adresse -->
            <div
              v-if="formClaim.object === 'Changement Adresse/Client'"
              class="form-group mb-3"
            >
              <label for="adresse">Adresse</label>
              <textarea
                id="adresse"
                v-model="formClaim.adresse"
                rows="3"
                class="form-control"
              ></textarea>
            </div>

            <!-- Commentaire -->
            <div
              :class="
                formClaim.object === 'Changement Adresse/Client'
                  ? 'form-group mb-3'
                  : 'form-group mb-3'
              "
            >
              <label for="comment">Commentaire</label>
              <textarea
                id="comment"
                v-model="formClaim.msg"
                rows="3"
                class="form-control"
              ></textarea>
            </div>

            <!-- Nouveau Client + Téléphone -->
            <div
              v-if="formClaim.object === 'Changement Adresse/Client'"
              class="form-group mb-3"
            >
              <div class="form-group mb-3">
                <label for="new_receiver">Nouveau Client</label>
                <input
                  id="new_receiver"
                  v-model="formClaim.new_receiver"
                  class="form-control"
                />
              </div>
              <div class="form-group mb-3">
                <label for="new_phone">Téléphone</label>
                <input
                  id="new_phone"
                  v-model="formClaim.new_phone"
                  class="form-control"
                />
              </div>
            </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          
        </div>
      </div>
    </div>
  </div>

  
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { Modal } from "bootstrap";
import ChatClaim from "./ChatClaim.vue";

export default {
  name: "NewCustomers",
  components: {
    ChatClaim, // register here
  },
  setup: () => {
    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    const headers = [
      {
          label: 'Référence',
          field: 'code',
        },
        {
          label: 'Object',
          field: 'object',
        },
        {
          label: 'Ville',
          field: 'name',
        },
        {
          label: 'Date d\'ajout',
          field: 'created_at',
        },
        {
          label: 'Etat',
          field: 'statut',
        },
        {
          label: 'Actions',
          field: 'action',
        },
    ];

    const objectsClaim = ref([]);

    const rows = ref([]);
    const loading = ref(false);
    const settingData = ref<any[]>([]);

    const showClaim = reactive({});
    const chatMsgs = ref([]);

    const users = reactive({
       searchCity:"",
        searchObject:"",
        searchStatut:"",
        searchSDate:"",
        searchEDate:"",
        searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    const formClaim = reactive({
      colis_id: 0,
      id: 0,
      customer_id: 0,
      msg: "",
      object: "",
      city_id: 0,
      statut: "",
      code_colis: "",
      city: "",
      adresse: "",
      city_name: "",
      new_receiver: "",
      new_phone: "",
      new_price: "",
      new_price_remb: "",
    });

    const formObject = reactive({
      new_object: { id: "", name: "" },
      msg: "",
      adresse: "",
      reciever: "",
      phone: "",
      price: "",
    });

    const claimObject = reactive<Record<string, any>>({});

    // helper to reset formObject
    function resetFormObject() {
      Object.assign(formObject, {
        new_object: { id: "", name: "" },
        msg: "",
        adresse: "",
        reciever: "",
        phone: "",
        price: "",
      });
    }

    // reset helper
    function resetForm() {
      Object.assign(formClaim, {
        colis_id: 0,
        id: 0,
        customer_id: 0,
        msg: "",
        object: "",
        city_id: 0,
        statut: "",
        code_colis: "",
        city: { id: 0, city: "" },
        adresse: "",
        new_receiver: "",
        new_phone: "",
        new_price: "",
        new_price_remb: "",
        city_name: "",
      });
    }

    // Fetch data from API
    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(`/api/auth/client/listClaims?searchTerm=${users.searchTerm}&searchCity=${users.searchCity}&searchObject=${users.searchObject}&searchStatut=${users.searchStatut}&searchSDate=${users.searchSDate}&searchEDate=${users.searchEDate}&page=${users.current_page}&per_page=${users.per_page}`);

        rows.value = res.data.users.data;
        Object.assign(users, res.data.users);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      fetchData();

     
    });

    function getDate(value: any) {
      if (value) return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    

    function showUpdate(row) {
      console.log(row)
      Object.assign(showClaim, row);
      fetchMessages(row.id);
      console.log(showClaim);
      const modalEl = document.getElementById("chatClaimModal");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }

      // your modal logic here
    }

   

    function showDetails(row) {
      resetForm();
      Object.assign(formClaim, row);

      if (row.city) {
        formClaim.city_id = row.city.id;
        formClaim.city_name = row.city.city;
      }
      console.log(formClaim);
      const modalEl = document.getElementById("infosClaimModal");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    async function fetchMessages(id: number | string) {
      const res = await api(
        `/api/auth/client/fetchMessages/${id}`
      );
      chatMsgs.value = res.data
        .sort(
          (a: { time: string }, b: { time: string }) =>
            new Date(b.time).getTime() - new Date(a.time).getTime()
        )
        .reverse();
    }

  
    function showObject(row) {
      // reset both objects
      resetFormObject();
      Object.assign(claimObject, row);

      // copy row into form
      Object.assign(formObject, row);

      // override new_object
      formObject.new_object = {
        id: row.object_id || "",
        name: row.object || "",
      };

      console.log(formObject);
      const modalEl = document.getElementById("chnageObjectClaimModal");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }


    const city_filter = ref({ id: '', name: '' });
    const status_filter = ref('');
    const object_filter = ref('');
    const date_filter = ref(null);
    const searchTerm = ref('');
   
    function filter(){
      users.searchCity= city_filter.value.id
      users.searchObject= object_filter.value
      users.searchStatut= status_filter.value
      // users.searchSDate= $refs.myInput.dateRange.start ===undefined ? '' : convert($refs.myInput.dateRange.start)
      // users.searchEDate= $refs.myInput.dateRange.end ===undefined ? '' : convert($refs.myInput.dateRange.end)
      users.current_page=1;
      fetchData();
      
    }
    function Removefilter(){
      users.searchCity= users.searchObject= users.searchStatut= '';
      users.searchSDate = users.searchEDate= '';
      status_filter.value = object_filter.value ='';
      city_filter.value={'id':'','name':''}
      // $refs.myInput.dateRange={}
      fetchData();
    }
    // Declare debounceTimer in the setup scope
    let debounceTimer: ReturnType<typeof setTimeout> | null = null;

    function handleInput() {
      // Clear previous debounce timer
      if (debounceTimer) clearTimeout(debounceTimer);

      // Set a new debounce timer
      debounceTimer = setTimeout(() => {
        const term = searchTerm.value;
        if (!term || term === '') {
          users.searchTerm = term;
          filter();
        } else if (term.length > 2) {
          users.searchTerm = term;
          filter();
        }
      }, 500); // Adjust the delay (in milliseconds) as needed
    }

    function getLastMsg(row){
      if(row){
        if(row.seen_customer==0) return true
        else return false;
      }else{
        return false;
      }
      
    }
    return {
      headers,
      rows,
      users,
      loading,
      fetchData,
      getDate,
      settingData,
      showDetails,
      showUpdate,
      chatMsgs,
      fetchMessages,
      showClaim,
      formClaim,
      showObject,
      formObject,
      objectsClaim,
      searchTerm,
      city_filter,
      status_filter,
      object_filter,
      date_filter,
      filter,
      Removefilter,
      handleInput,
      getLastMsg,

    };
  },
};
</script>
